import React from 'react';
import FieldSelect from '../FieldSelect/FieldSelect';
import { sortOptionsByKeyIntl } from '../../util/genericHelpers';
import css from './CustomExtendedDataField.module.css';
import { brandIndustriesOptions } from '../../util/enums';

function RenderBrandIndustries({ name, formId, label, validateMaybe, placeholder, filterOptions }) {
  return (
    <FieldSelect
      className={css.customField}
      name={name}
      id={formId ? `${formId}.${name}` : name}
      label={label}
      {...validateMaybe}
    >
      <option disabled value="">
        {placeholder}
      </option>
      {sortOptionsByKeyIntl([filterOptions, ...brandIndustriesOptions], 'label').map(
        ({ value, label }) => (
          <option key={`${value}_${label}`} value={value}>
            {label}
          </option>
        )
      )}
    </FieldSelect>
  );
}

export default RenderBrandIndustries;
